import * as Yup from 'yup'
export const validationSchema = Yup.object().shape({
  product_id: Yup.number().required('Product must be choosen!'),
  supplier_id: Yup.number().required('Supplier must be choosen!'),
  currency_id: Yup.number().required('Currency must be choosen!'),
  price: Yup.string().required('Price must be!')
})
